import { Component, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { SidenavService } from '../../services/sidenav.service';
import { SnackbarService } from '../../services/snackbar.service';
import { UsersService } from '../../services/users.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: false,
})
export class ProfileComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  sidenav: MatSidenav;
  user: any;
  userId: string;
  isAdminView = false;

  constructor(
    private sidenavService: SidenavService,
    private usersService: UsersService,
    private route: ActivatedRoute,
    private snackbar: SnackbarService,
    private router: Router,
  ) {
    this.sidenav = this.sidenavService.getSidenav();
    this.user = {};
  }

  async ngOnInit() {
    this.userId = this.route.snapshot.params['id'];
    this.isAdminView =
      this.route.snapshot.routeConfig?.path === 'admin/users/:id';
    this.user = await this.usersService.get(this.userId);
  }

  toggleMenu() {
    this.sidenavService.toggle();
  }

  goBack() {
    this.router.navigate(['/admin/users']);
  }

  update() {
    this.blockUI.start();
    this.usersService
      .update(this.user)
      .then(() => {
        this.blockUI.stop();
        this.snackbar.success('El usuario se ha actualizado correctamente.');
      })
      .catch((error) => {
        this.blockUI.stop();
        this.snackbar.error(error.message);
      });
  }
}
